/* eslint-disable react/no-array-index-key */
import React, { ReactElement } from 'react';
import { Text } from '@chakra-ui/react';

export const transformMarkToBoldText = (text: string): ReactElement => {
  const regex = /<mark>(.*?)<\/mark>|([^<>]+)/g;
  const matches = Array.from(text.matchAll(regex));
  let isFirstBoldFound = false;

  return (
    <>
      {matches.map(([_, boldText, normalText], index) => {
        if (boldText && !isFirstBoldFound) {
          // Text inside <mark>
          isFirstBoldFound = true;
          return (
            <Text
              as="span"
              textStyle="body.s.medium"
              color="text.secondary"
              key={`${index}-${boldText}`}
            >
              {boldText}
            </Text>
          );
        }
        // Other text
        return (
          <Text key={index} textStyle="body.s.regular" display="inline" color="text.tertiary">
            {boldText || normalText}
          </Text>
        );
      })}
    </>
  );
};
